import CisionStockDiagramPage from './CisionStockDiagramPage';

export default CisionStockDiagramPage;
